import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;

  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(2px);

  p {
    margin: 0;
    color: #354985;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    max-width: 80vw;
  }

  .loader {
    width: 96px;
    height: 96px;
    border: 10px solid #e6e6e6;
    border-top-color: #354985;
    border-radius: 50%;
    animation: girar 1s linear infinite;
  }

  @keyframes girar {
    to {
      transform: rotate(360deg);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .loader {
      animation-duration: 3s;
    }
  }
`;
